import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@vanialabs/core-auth';

interface ProtectedRouteProps {
  children: ReactNode;
  redirectTo?: string;
}

export function ProtectedRoute({
  children,
  redirectTo = '/login',
}: ProtectedRouteProps) {

  const isInitialized = useAuthStore(
    (state) => state.isInitialized
  );

  const isAuthenticated = useAuthStore(
    (state) => state.isAuthenticated()
  );

  const location = useLocation();


  if (!isInitialized) {
    return null;
  }


  if (!isAuthenticated) {
    return (
      <Navigate
        to={redirectTo}
        replace
        state={{
          from: location,
        }}
      />
    );
  }


  return <>{children}</>;
}
